<div class="flex flex-column gap8 p-r p-l">
    @for (notification of visibleNotifications(); track notification.id) {
    <app-user-notification-modal-item class="_item"
                                      [notification]="notification"
                                      (closeNotification)="handleNotificationClose($event)">
    </app-user-notification-modal-item>
    }
</div>
